import { useSelector } from 'react-redux'
import SeedTrackerSelectors from 'modules/domain/seedTracker/selectors'
import { Progress } from 'modules/types'
import SeedTrackerActions from 'modules/domain/seedTracker/duck'
import { SeedTracker, SeedTrackerListMeta, SeedTrackerListRequestFilter } from 'modules/domain/seedTracker/types'
import { useAction, useDidMount, usePageQuery } from '@agro-club/frontend-shared'

export const useSeedTrackerList = ({
  filter,
  pageSize,
}: { filter?: SeedTrackerListRequestFilter; pageSize?: number } = {}): readonly [
  Progress,
  SeedTracker[] | undefined,
  SeedTrackerListMeta | undefined,
] => {
  const progress = useSelector(SeedTrackerSelectors.listFetchProgress)
  const list = useSelector(SeedTrackerSelectors.seedTrackerList)
  const listMeta = useSelector(SeedTrackerSelectors.listMeta)
  const page = usePageQuery()
  const params: { filter?: SeedTrackerListRequestFilter; page?: number; pageSize?: number } = {}
  if (filter) params.filter = filter
  if (page) params.page = page
  if (pageSize !== undefined) params.pageSize = pageSize
  const fetchAction = useAction(SeedTrackerActions.listRequested, page ? { page } : {})

  useDidMount(() => {
    if (progress !== Progress.SUCCESS) {
      fetchAction()
    }
  })

  return [progress, list, listMeta]
}
